export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/constant.js
// module id = 805
// module chunks = 0 1